import i18n from "../i18n";

// Região usada na formatação de cada idioma do checkout. es-419 (espanhol da América
// Latina) usa separador de milhar e decimal como os países que mais compram de fora.
const NUMBER_LOCALES: Record<string, string> = {
    "pt-BR": "pt-BR",
    en: "en-US",
    es: "es-419",
};

/** Locale de números/moeda do idioma atual do checkout (pt-BR quando não definido). */
export const getNumberLocale = (): string => NUMBER_LOCALES[i18n.resolvedLanguage ?? ""] ?? "pt-BR";

const formatCurrency = (value: number, currency: string): string => {
    const locale = getNumberLocale();
    // Em es-419 o real sairia "BRL 30.00"; o símbolo curto fica "R$30.00", mais claro pro comprador.
    const currencyDisplay = locale === "es-419" && currency === "BRL" ? "narrowSymbol" : "symbol";
    return value.toLocaleString(locale, { style: "currency", currency, currencyDisplay });
};

const format = (value?: number, fractional?: number, prefixMoney?: boolean, def?: number): string => {
    if (value === undefined || value === null) {
        value = def;
    }

    if (value === undefined || value === null) {
        return '';
    }

    var money = "";

    if (prefixMoney) {
        money = formatCurrency(value, 'BRL');
        return money;
    }

    money = value.toLocaleString(getNumberLocale(), { minimumFractionDigits: fractional });
    return money;
}

const formatMoney = (value?: number, prefixMoney?: boolean, def?: number) => {
    return format(value, 2, prefixMoney, def);
}

const formatMoneyDefault = (value?: any) => {
    const number = toNumber(value);
    return formatMoney(number, true, 0);
}

const formatMoneyCurrency = (value?: any, currency?: string | null): string => {
    const number = toNumber(value)
    const curr = (currency ?? 'BRL').toUpperCase()
    if (curr === 'BRL') {
        return formatMoney(number, true, 0)
    }
    try {
        return formatCurrency(Number(number ?? 0), curr)
    } catch {
        // Código de moeda que o Intl não conhece: mantém o formato antigo.
        return `${curr} ${Number(number ?? 0).toFixed(2)}`
    }
}

const toNumber = (value: any) => {
    if ((typeof value) === 'string') {
        value = String(value).replace(",", ".");
        return Number(value);
    }
    return value;
}

const toPercentage = (value?: any) => {
    value = toNumber(value || 0);
    const percentage = Number(value).toLocaleString(getNumberLocale(), { maximumFractionDigits: 20, useGrouping: false });
    return `${percentage}%`;
}

const getRandomInt = (max: number) => {
    return Math.floor(Math.random() * max);
}

const round = (value: number, fractional?: number) => {
    fractional ??= 2;
    return Number(value.toFixed(fractional));
}

const stripDDIPlus = (ddi: string): string => ddi.replace("+", "")

const NumberFunctions = {
    format,
    formatMoney,
    formatMoneyDefault,
    formatMoneyCurrency,
    toNumber,
    toPercentage,
    getRandomInt,
    round,
    stripDDIPlus,
}

export default NumberFunctions;
